<template>
    <div class="container">
      <div class="loginPage">
        <div class="row justify-content-center deep-shadow">
        
          <div class="d-flex">
            <div class="w-100">
              <h3 class="mb-4">
                Sign In
              </h3>
            </div>
          </div>
          <div class="errors" v-if="has_error">
              Username & Password are invalid! Please try again.
            </div>
            <form class="col-md-12" v-on:submit.prevent="login()">
                <div class="warp">
                    <div class="form-group mt-3">
                        <label for="email" class="form-control-placeholder">Email</label>
                        <input type="email" id="email" v-model="email" class="form-control"/>
                    </div>
                    <div class="form-group mt-3">
                        <label for="password" class="form-control-placeholder">Password</label>
                        <input type="password" id="password" v-model="password" class="form-control"  />
                    </div>
                </div>
            
                <div class="form-group mt-3">
                    <div v-if="this.getLoadStatus">
                        <button type="submit" class="form-control btn btn-warning rounded submit px-3" disabled>Loading...</button>
                    </div>
                    <div v-else>
                        <button type="submit" class="form-control btn btn-warning rounded submit px-3">Login</button>
                    </div>
                </div>
            </form>
        </div>
      </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    export default {
        data() {
          return {
            email: '',
            password: '',
            has_error: false
          }
        },
        methods: {
          login() {
            // get the redirect object
            var app = this
            this.$auth.login({
              body: {
                email: app.email,
                password: app.password
              },
              success: function(response) {
                if (response.body.success) {
                  Vue.prototype.$authtoken = 'Bearer '+response.body.Token
                  // handle redirection
                  localStorage.setItem('token', 'Bearer '+response.body.Token)
                  localStorage.setItem('user_role', response.body.user_role)
                  //this.$router.push({name: redirectTo})
                  this.$router.push('bookings')
                } else {
                  return
                }
                
              },
              error: function() {
                app.has_error = true
              },
              rememberMe: true,
              staySignedIn: true,
              fetchUser: false
            })
          }
        }
    }
</script>
